import { render, staticRenderFns } from "./MonitorWork.vue?vue&type=template&id=e2ec4ff0&scoped=true"
import script from "./MonitorWork.vue?vue&type=script&lang=js"
export * from "./MonitorWork.vue?vue&type=script&lang=js"
import style0 from "./MonitorWork.vue?vue&type=style&index=0&id=e2ec4ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ec4ff0",
  null
  
)

export default component.exports